import { IllustrationName } from '@pandiafi/design-system'

import { OperationConfirmationState } from '../../../../common/validations'

export const resolveOperationConfirmationIllustration = (
  state: OperationConfirmationState
): IllustrationName => {
  switch (state) {
    case OperationConfirmationState.CONFIRMED:
      return 'house-bye'
    case OperationConfirmationState.PENDING:
      return 'paper-plane'
    case OperationConfirmationState.REJECTED:
      return 'house-unhappy'
    default:
      return 'house-missing'
  }
}
